import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
/*
  The gilded skin's structural rules. AFTER ./index.css on purpose: index.css is where
  @tailwind utilities expands, and these rules have to land after that layer. See the
  load-order note at the top of the file — do not reorder these two imports, and do not
  fold this into an @import inside index.css, where CSS's "@import comes first" rule
  would put it before the utilities it overrides.

  Inert unless the build stamped data-skin="gilded" (see .env / src/skin.ts).
*/
import './skins/gilded.css';
/* The event skin's structure, same load-order rule. Inert unless data-skin="event". */
import './skins/event.css';
import App from './App/App';
import reportWebVitals from './reportWebVitals';

const rootNode = document.getElementById('root');
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>  
, rootNode);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
